var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('next-steps-base-card',{attrs:{"title":"להתכונן לתוכניות גדולות ולחסוך אליהן בכל חודש","button-text":"לפתיחת תוכנית","description":"10 דקות, להסתכל קדימה","action-key":_vm.actionKey},on:{"click":_vm.goToPlanAhead}})}
var staticRenderFns = []

export { render, staticRenderFns }